import { captureException } from "./sentry";

export const sendPageViewEvent = (data) => {
	try {

		window?.gtag('event', 'page_view', {
			...data,
			send_to: 'UA-106059107-4'
		})
		window?.fbq('trackSingle', '668158800558412', 'PageView');

	} catch (e) {
		console.error(e);
		captureException(e, "info", {}, { action: "sendPageViewEvent" }, { scope: "analytics.js" });
	}
};

export const sendEvent = (data) => {
	const { category, action, label, value } = data;
	try {

		window?.gtag('event', action, {
			event_category: category,
			event_label:  label || "",
			value: value || "",
			send_to: 'UA-106059107-4'
		});

	} catch (e) {
		console.error(e);
		captureException(e, "info", {}, { action: "sendEvent" }, { scope: "analytics.js" });
	}
};

export const validateUA = (ua) => {
	return ua && ua.match(/^UA-\d{4,9}-\d{1,3}$/);
};
